import React from 'react';
import HorizontalGroup from './HorizontalGroup';
import HorizontalCollapse from './HorizontalCollapse';
import HorizontalItem from './HorizontalItem';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import PropTypes from 'prop-types';

const HorizontalNav = ({ routesConfig }) => {
  return (
    <List className='navbarNav'>
      {routesConfig?.map((item) =>
        item?.children ? (
          item?.children?.map((child) => (
            <React.Fragment key={child.id}>
              {child.type === 'collapse' && (
                <HorizontalCollapse item={child} nestedLevel={0} />
              )}

              {child.type === 'item' && (
                <HorizontalItem item={child} name={item} nestedLevel={0} />
              )}

              {child.type === 'divider' && <Divider sx={{ my: 5 }} />}
            </React.Fragment>
          ))
        ) : (
          <HorizontalItem item={item} name={item} nestedLevel={0} />
        ),
      )}
    </List>
  );
};

export default HorizontalNav;
HorizontalNav.propsTypes = {
  routesConfig: PropTypes.array.isRequired,
};
